import axios from 'axios';
import API_BASE_URL from '../config/api';

// Créer une instance axios pour les notifications
const notificationApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Intercepteur pour ajouter le token d'authentification
notificationApi.interceptors.request.use(
  (config) => {
    // Prioriser le token restaurant pour les restaurateurs
    const restaurantToken = localStorage.getItem('restaurantToken');
    const userToken = localStorage.getItem('access_token');
    const token = restaurantToken || userToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs de réponse
notificationApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      // Ne pas rediriger si on est dans le dashboard restaurant
      const isRestaurantPage = window.location.pathname.startsWith('/management');
      if (!isRestaurantPage) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        // Ne pas rediriger les restaurants vers /login
        const restaurantToken = localStorage.getItem('restaurantToken');
        if (!restaurantToken) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

// API des notifications
export const notificationAPI = {
  // Récupérer les notifications de l'utilisateur
  getNotifications: async (params = {}) => {
    try {
      const response = await notificationApi.get('/notifications/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications:', error);
      throw error;
    }
  },

  // Récupérer le nombre de notifications non lues
  getUnreadCount: async () => {
    try {
      const response = await notificationApi.get('/notifications/unread-count');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du compteur:', error);
      throw error;
    }
  },

  // Récupérer le nombre de notifications non lues par catégorie (pour badges par onglet)
  getUnreadCountByCategory: async () => {
    try {
      const response = await notificationApi.get('/notifications/unread-count-by-category');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des compteurs par catégorie:', error);
      return { total: 0, by_category: {} };
    }
  },

  // Marquer une notification comme lue
  markAsRead: async (notificationId) => {
    try {
      const response = await notificationApi.put(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du marquage comme lu:', error);
      throw error;
    }
  },

  // Marquer toutes les notifications comme lues
  markAllAsRead: async (category = null) => {
    try {
      const params = category ? { category } : {};
      const response = await notificationApi.put('/notifications/mark-all-read', {}, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du marquage de toutes les notifications:', error);
      throw error;
    }
  },

  // Supprimer une notification
  deleteNotification: async (notificationId) => {
    try {
      const response = await notificationApi.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      throw error;
    }
  },

  // Créer une notification de test (pour développement)
  createTestNotification: async () => {
    try {
      const response = await notificationApi.post('/notifications/test');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la notification de test:', error);
      throw error;
    }
  },

  // Fonctions utilitaires pour gérer l'état des notifications
  // (Le hook React sera créé séparément dans un fichier hooks)

  // Créer une notification de test
  createTestNotification: async () => {
    try {
      const response = await notificationApi.post('/notifications/test');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la notification de test:', error);
      throw error;
    }
  }
};

export default notificationAPI;